import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";
import { useAuth } from "@/auth/AuthContext";
import { useApi } from "@/lib/api";

export function useResourceTags() {
  const { accessToken } = useAuth();
  const api = useApi();
  const { orgId } = useParams();
  const [tags, setTags] = useState<{ key: string; value: string }[]>([]);

  useEffect(() => {
    if (!accessToken || !orgId) {
      return;
    }

    let cancelled = false;

    void api
      .get<{ key: string; value: string }[]>(
        `/organizations/${orgId}/resources/tags`,
      )
      .then((data) => {
        if (!cancelled) {
          setTags(data ?? []);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [accessToken, api, orgId]);

  const tagKeys = useMemo(() => [...new Set(tags.map((t) => t.key))], [tags]);

  const tagValuesFor = useCallback(
    (key: string) => [
      ...new Set(tags.filter((t) => !key || t.key === key).map((t) => t.value)),
    ],
    [tags],
  );

  return { tagKeys, tagValuesFor };
}
